import CHART_ACTIONS from "../actionTypes/charts";

export const chartDataFetched = payload => ({ type: CHART_ACTIONS.CHART_DATA_SUCCESS, payload });
export const resetChartData = payload => ({ type: CHART_ACTIONS.RESET_CHART_DATA });
export const resetChartTagsData = payload => ({ type: CHART_ACTIONS.RESET_CHART_TAGS_DATA });
export const resetTagsData = payload => ({ type: CHART_ACTIONS.RESET_TAGS_DATA });
export const setChartLoading = payload => ({ type: CHART_ACTIONS.SET_CHART_LOADING, payload });
export const setChartTagDataLoading = payload => ({ type: CHART_ACTIONS.SET_CHART_TAG_DATA_LOADING, payload });
export const setChartTags = payload => ({ type: CHART_ACTIONS.SET_CHART_TAGS, payload });
export const setPlotData = payload => ({ type: CHART_ACTIONS.SET_PLOT_DATA, payload });
export const updatePlotData = payload => ({ type: CHART_ACTIONS.UPDATE_PLOT_DATA, payload });
export const updateChartFormat = payload => ({ type: CHART_ACTIONS.UPDATE_CHART_FORMAT, payload });
export const updateChartDuration = payload => ({ type: CHART_ACTIONS.UPDATE_CHART_DURATION, payload });
export const setChartDurationRanges = payload => ({ type: CHART_ACTIONS.SET_DURATION_RANGES, payload });
export const addedNewTag = payload => ({ type: CHART_ACTIONS.ADD_TAG_SUCCESS, payload });
export const deletedTag = payload => ({ type: CHART_ACTIONS.DELETE_TAG_SUCCESS, payload });
export const updateTagsWithoutData = payload => ({ type: CHART_ACTIONS.UPDATE_TAGS_WITHOUT_DATA, payload });
export const setEditCurrentView = payload => ({ type: CHART_ACTIONS.SET_CURRENT_EDITVIEW, payload });
export const updateEditedTags = payload => ({ type: CHART_ACTIONS.UPDATE_EDITED_TAGS, payload });
export const setAlarmsHistory = payload => ({ type: CHART_ACTIONS.SET_ALARMS_HISTORY, payload });
export const updateAlarms = payload => ({ type: CHART_ACTIONS.UPDATE_ALARMS, payload });
export const updateNormalizeFilters = payload => ({ type: CHART_ACTIONS.UPDATE_NORMALIZE_FILTERS, payload });
export const onPlotZoom = payload => ({ type: CHART_ACTIONS.ON_CHART_PLOT_ZOOM, payload });
export const tagsLimits = payload => ({ type: CHART_ACTIONS.TAGS_LIMITS, payload });
const ChartActions = {
  chartDataFetched,
  setChartLoading,
  setChartTagDataLoading,
  resetChartData,
  resetTagsData,
  setChartTags,
  setPlotData,
  updatePlotData,
  resetChartTagsData,
  updateChartFormat,
  updateChartDuration,
  setChartDurationRanges,
  addedNewTag,
  deletedTag,
  updateTagsWithoutData,
  setEditCurrentView,
  updateEditedTags,
  setAlarmsHistory,
  updateAlarms,
  updateNormalizeFilters,
  onPlotZoom,
  tagsLimits
};

export default ChartActions;
